export class RecipientRole {
  static MeritoricEmployee = 1;
  static TechnicalEmployee = 2;
  static ClientContact = 3;
  static OtherEmployee = 4;
  static Other = 5;
  static WorkshopSharingPlace = 6;
  static WorkshopRedirectingToRepair = 7;
  static OtherWorkshop = 8;
  static DefaultEmployeeForWorkshopCommunication = 9;
  static WorkshopSharingPlaceGeneral = 10;
  static WorkshopRedirectingToRepairGeneral = 11;
  static InsuranceCompanyGeneral = 12;
  static ClaimInvoiceCustomer = 13;
  static ClaimInvoiceBuyer = 14;
  static ClaimInvoicePayer = 15;
  static ClientReportingContact = 16;
  static TechnicalExpertEmployee = 17;
  static PartsEmployee = 18;
  static DefaultEmployeeForPartsSupplierCommunication = 19;

  static RolesForSms = [
    RecipientRole.MeritoricEmployee,
    RecipientRole.TechnicalEmployee,
    RecipientRole.TechnicalExpertEmployee,
    RecipientRole.PartsEmployee,
    RecipientRole.ClientContact,
    RecipientRole.ClientReportingContact,
    RecipientRole.Other];

  static RolesForEmail = [
    RecipientRole.MeritoricEmployee,
    RecipientRole.TechnicalEmployee,
    RecipientRole.TechnicalExpertEmployee,
    RecipientRole.PartsEmployee,
    RecipientRole.ClientContact,
    RecipientRole.ClientReportingContact,
    RecipientRole.Other,
    RecipientRole.WorkshopSharingPlaceGeneral,
    RecipientRole.WorkshopRedirectingToRepairGeneral,
    RecipientRole.InsuranceCompanyGeneral,
    RecipientRole.ClaimInvoiceCustomer,
    RecipientRole.ClaimInvoiceBuyer,
    RecipientRole.ClaimInvoicePayer];

  static RolesForPortalMessage = [
    RecipientRole.MeritoricEmployee,
    RecipientRole.TechnicalEmployee,
    RecipientRole.TechnicalExpertEmployee,
    RecipientRole.PartsEmployee,
    RecipientRole.OtherEmployee,
    RecipientRole.WorkshopSharingPlace,
    RecipientRole.WorkshopRedirectingToRepair,
    // RecipientRole.OtherWorkshop
  ];

}
